import React from 'react';
import { MobileMenuButtonContainer } from './styles';

const MobileMenuButton = ({ isMobileMenuOpened, mobileIconClicked }) => (
  <MobileMenuButtonContainer data-testid="mobile-menu-button">
    {isMobileMenuOpened ? (
      <div className="mobile-menu--close-icon" onClick={mobileIconClicked}></div>
    ) : (
      <div className="mobile-menu--icon" onClick={mobileIconClicked}>
        <span></span>
      </div>
    )}
  </MobileMenuButtonContainer>
);

export default MobileMenuButton;
